import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {ConvertToJalali, RewardsData} from "../../StoreDetail/StoreDetailServices";
import {FestivalData} from "../../Festival/FestivalServices";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";

const CampaignList = ({item}) =>{

    //vars
    const history = useHistory();
    const [festivals,setFestivals] = useState([])


    const imageParams_ = {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }

    const imageParams = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 40
            },
            768: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            400: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            320: {
                slidesPerView: 'auto',
                spaceBetween: 10
            }
        }
    }





    //fetch festivals ------------------------------------------------------
    const getFestivals = async () => {
        try{
            let response = await FestivalData();
            let Campaigns = response.data.sortBy('order');
            setFestivals(Campaigns);
        }catch (e) {
            // console.log(e)
        }
    }

    useEffect(()=>{
        getFestivals(item.mall_uid)
    },[])



    return(
        <div className="CampaignList-container" style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            {/*Festival*/}
            <div className="storeDetail-festival">
                {festivals && festivals.length>0?<div  className="storeDetail-festival-titre">
                    جشنواره ها
                </div>:null}
                <div className="storyDetail-festival-slider">
                    {festivals && festivals.length>0? <SwiperId {...imageParams}>
                        {festivals.map(reward=>{
                            return(
                                <div key={reward.uid} className="Store-slide" onClick={()=>{
                                    history.push(`/festival-detail/${reward.uid}`,{festival:{uid:reward.uid}})
                                }}>
                                    <img src={reward.image || reward.cover} alt=""/>
                                    <div className="festival-slide-title">
                                        <span>{reward.title}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </SwiperId>:null}
                </div>

            </div>
        </div>
    )
}

export {CampaignList}
